// extracted by mini-css-extract-plugin
module.exports = {"groupHeaderText":"BoldIfGroupHeader_groupHeaderText__25GMn"};